<template>
  <div id="StaffSelectModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">担当者選択</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>担当者コード</th><td><input type="text" v-model="salesStaffCode"/></td>
              <th>担当者名</th><td><input type="text" v-model="name" /></td>
              <th>営業所</th>
              <td>
                <select v-model="salesOfficeCode">
                  <option v-for="salesOffice in salesOfficeList" :value="salesOffice.code" :key="salesOffice.code">{{ salesOffice.name }}</option>
                </select>
              </td>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="customerSelectTable"
            :data="data"
            paginated
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="customerId" label="" width="20" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="staffId" label="担当者コード" width="100" centered>{{props.row.salesStaffCode }}</b-table-column>
              <b-table-column field="staffName" label="担当者名" width="150" >{{props.row.name}}</b-table-column>
              <b-table-column field="salesOffice" label="担当営業所" width="250" >{{props.row.salesOfficeCode | officeFilter(salesOfficeList)}}</b-table-column>
              <b-table-column field="staffMail" label="メールアドレス" width="400" >{{props.row.mail}}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "StaffSelectModal",
  props: {
    selectRole:{type:[Array], default: () => [], },
    kindService:{type:String, default: ''},
    index:{type:Number, default: null},
  },
  methods: {
    save: function() {
      this.$emit('select', this.selectedItem, this.kindService, this.index);
      this.$parent.close();
    },
    doSearch: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getUserListPOST({
            body:{
              salesStaffCode: _this.salesStaffCode,
              name:  _this.name,
              mail: "",
              salesOfficeCode: _this.salesOfficeCode,
              authorityCode: _this.selectRole
            }
          });
        },
        async function(result){
          if(result.obj.length < 1){
            _this.showMessage('該当する担当者は存在しません。');
          }
          _this.data = result.obj;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      ); 
    },
  },
  data() {
    var salesOfficeList = this.getSalesOfficeMaster();
    salesOfficeList.unshift({});
    return {
      data: [],
      salesOfficeList,
      salesStaffCode:"",
      name:"",
      salesOfficeCode:"",
      selectedItem:'',
      hasResult: false
    };
  },
  filters: {
    officeFilter(value,officeList){
      var target = officeList.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },
  },
  components: {},
  mounted: function () {},
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/StaffSelectModal.vue